import BodyText from "./BodyText";
import Box from "./Box";
import DropdownSection from "./DropdownSection";
import React from "react";
import RichText from "./RichText";
import { withTheme } from "styled-components";
import { useTakebackConfig } from "./TakebackConfigContext";

function TakebackRules({ theme }) {
  const { takebackRules } = useTakebackConfig();

  return (
    <Box
      borderTop={`2px solid ${theme.colors.offForeground}`}
      borderBottom={`2px solid ${theme.colors.offForeground}`}
      py={15}
    >
      <DropdownSection
        heading="Read takeback rules"
        content={
          <Box py={25} pl={[0, null, 38, null]}>
            <Box pb={40}>
              <RichText>{takebackRules}</RichText>
            </Box>
            <BodyText
              dangerouslySetInnerHTML={{
                __html:
                  "Read the full takeback <a style='text-decoration:underline;' href='https://www.reskinned.clothing/pages/takeback/takeback-terms-and-conditions' target='_blank'>terms and conditions</a>",
              }}
            />
          </Box>
        }
      />
    </Box>
  );
}

export default withTheme(TakebackRules);
